// extracted by mini-css-extract-plugin
export default {"root":"Agent__root--Rhmi0","image":"Agent__image--ErIj5","details":"Agent__details--FKpg8","name":"Agent__name--QBGVk","phone":"Agent__phone--ogIrF","email":"Agent__email--GSfya"};